// 中文（简体）
export default {
    // Research papers page (/research)
    "nav.globe": "地球仪",
    "nav.research": "研究",
    "rs.title": "研究论文",
    "rs.sub": "来自 arXiv、美联储、欧洲央行、国际清算银行和 NBER 的最新量化金融与央行研究。可在原始来源免费阅读；每 6 小时更新。",
    "rs.search": "搜索标题、作者、摘要…",
    "rs.allTopics": "全部主题",
    "rs.allSources": "全部来源",
    "rs.allCountries": "全部国家",
    "rs.count": "{n} 篇论文",
    "rs.none": "没有符合这些筛选条件的论文。",
    "rs.clear": "清除筛选",
    "rs.download": "从 {source} 下载 PDF",
    "rs.read": "在 {source} 阅读",
    "rs.onGlobe": "在地球仪上打开{country}",
    "rs.note": "标题、作者和摘要链接到原始发布方；PDF 在其网站上打开。仅为研究内容，并非投资建议。",
    "rs.global": "全球",
    "rs.loadMore": "加载更多",
    "rs.details": "详情",
    "rs.copy": "复制链接",
    "rs.copied": "链接已复制",
    "rs.published": "发布日期",
    "panel.research": "关于{country}的研究",
    "panel.researchAll": "全部研究 →",
    "rt.trading": "交易与市场结构",
    "rt.portfolio": "投资组合与投资",
    "rt.risk": "风险",
    "rt.pricing": "衍生品与定价模型",
    "rt.forecasting": "人工智能与预测",
    "rt.crypto": "加密货币与数字资产",
    "rt.macro": "经济与央行",
    "topic.r-trading": "交易研究探讨价格如何形成以及订单如何执行：策略、订单簿、流动性和交易成本。",
    "topic.r-portfolio": "投资组合研究探讨如何组合投资：哪些因子解释收益、如何平衡风险与收益，以及如何为退休投资。",
    "topic.r-risk": "风险研究衡量可能出现的问题：巨额亏损、市场崩盘、银行倒闭以及如何防范。",
    "topic.r-pricing": "定价研究构建为期权和其他合约估值的数学方法，以及波动率模型。",
    "topic.r-forecasting": "人工智能与预测研究检验机器学习、语言模型和统计方法能否预测价格或经济，以及可靠程度。",
    "topic.r-crypto": "加密研究探讨加密货币、稳定币、区块链和代币化资产：它们如何交易以及有哪些风险。",
    "topic.r-macro": "经济研究关注增长、通胀、利率和央行政策，这些因素在数月乃至数年内推动市场。",
    'lang.label': '语言',
    'nav.reports': '报告',
    'nav.stocks': '股票关注',
    loading: '正在加载全球新闻…',
    'err.title': '无法加载',
    'err.msg': '加载应用时出现问题。',
    'err.retry': '重试',
    atlas: '地图集',
    'search.label': '搜索国家',
    'search.ph': '搜索国家或代码…',
    'filter.region': '地区',
    'filter.allRegions': '所有地区',
    'filter.window': '时间范围',
    'filter.topic': '主题',
    'filter.all': '全部',
    'stage.title': '此刻的市场',
    legend: '图例',
    lastUpdate: '最近更新',
    pauseRotation: '暂停旋转',
    resumeRotation: '继续旋转',
    hint: '拖动以旋转 · 点击圆点打开国家',
    'panel.latest': '最新',
    'quiet.none': '此时间范围内没有新闻。',
    'quiet.sub': '试试更长的时间范围（7天或30天），或关注这个国家，把它留在你的列表中。',
    'footer.about': '关于',
    'footer.privacy': '隐私',
    'footer.terms': '条款',
    follow: '☆ 关注',
    following: '★ 已关注',
    followingGroup: '已关注',
    explain: '解释一下',
    hideExplain: '收起解释',
    share: '分享',
    whyMatter: '为什么可能重要',
    disclaimer: '仅供学习参考，不构成投资建议。',
    readAt: '在 {source} 阅读全文',
    translate: '翻译',
    showing: '显示 {n} / {total}',
    loadMore: '再加载 {n} 条',
    loadingShort: '加载中…',
    'story.one': '{n} 条新闻',
    'story.other': '{n} 条新闻',
    noStories: '暂无新闻',
    justNow: '刚刚',
    minAgo: '{n} 分钟前',
    hAgo: '{n} 小时前',
    dAgo: '{n} 天前',
    'range.24h': '过去 24 小时',
    'range.7d': '过去 7 天',
    'range.30d': '过去 30 天',
    'range.all': '全部时间',
    'cont.Africa': '非洲',
    'cont.Asia': '亚洲',
    'cont.Europe': '欧洲',
    'cont.North America': '北美洲',
    'cont.Oceania': '大洋洲',
    'cont.South America': '南美洲',
    'cat.markets': '市场',
    'cat.economy': '经济',
    'cat.central-banks': '央行',
    'cat.policy': '政策与地缘政治',
    'cat.companies': '公司',
    today: '今日',
    'today.top': '60 秒看世界',
    'today.banks': '央行决议',
    'today.mine': '你的国家',
    'today.emptyTop': '今天暂时没有重要新闻，请稍后再来。',
    'today.emptyMine': '在任意国家点击 ☆ 关注，即可固定在这里。',
    'today.note': '标题链接到原始发布者。仅供学习参考，不构成投资建议。',
    'today.open': '打开 {country}',
    close: '关闭',
    'cal.timeVaries': '时间不固定',
    'cal.yourTime': '你的时间 {time}',
    'cal.in': '{t} 后',
    'cal.today': '今日公布决议',
    'bank.fed': '美联储',
    'bank.ecb': '欧洲央行',
    'bank.boe': '英国央行',
    'bank.boj': '日本央行',
    'auth.signIn': '登录',
    'auth.account': '账户',
    'auth.btnTitle': '免费账户：在所有设备上保存你的国家',
    'auth.freeTitle': '免费账户',
    'auth.freeSub': "在所有设备上保存你关注的国家。无需密码：我们会通过邮件发送一次性验证码。",
    'auth.emailBtn': "通过邮件发送登录验证码",
    'auth.sending': '发送中…',
    'auth.check': '请查看邮箱中的登录链接（20 分钟内有效）。',
    "auth.codeTitle": "请查看邮箱",
    "auth.codeSent": "我们已将 6 位验证码发送至 {email}。请在此输入：",
    "auth.codeLabel": "登录验证码",
    "auth.codeBtn": "登录",
    "auth.junk": "没有收到？可能需要一分钟。也请查看垃圾邮件文件夹，并将其标记为“非垃圾邮件”，以便之后的邮件进入收件箱。",
    "auth.otherEmail": "使用其他邮箱",
    'auth.dev': '开发模式（未配置邮件服务器）：',
    'auth.devLink': '点击这里登录',
    'auth.fine': '我们只用你的邮箱来登录。详见{link}。',
    'auth.privacy': '隐私声明',
    'auth.yourAccount': '你的账户',
    'auth.signedInAs': '已登录：{email}',
    'auth.followCount': '已关注 {n} 个国家，已在所有设备间同步。',
    'auth.signOut': '退出登录',
    'auth.delete': '删除我的账户',
    "auth.confirmDelete": "删除你的账户？这将清除你的邮箱地址和已保存的国家，并停止发送 NewsNetWide 邮件。此操作无法撤销。",
    'auth.deletedTitle': '账户已删除',
    "auth.deletedSub": "你的邮箱、已保存的国家和邮件订阅均已删除。",
    'auth.inTitle': '你已登录',
    'auth.inSub': '欢迎，{email}。你关注的国家现已保存到账户中。',
    'auth.expired': '该链接已过期，请在下方重新获取。',
    'auth.used': '该链接已被使用或无效，请在下方重新获取。',
    'share.source': '来源',
    'share.tagline': '所有影响市场的新闻，尽在一个地球仪',
    'share.notAdvice': '新闻资讯，不构成投资建议',
    'mc.open': '开市',
    'mc.pre': '盘前',
    'mc.post': '盘后',
    'mc.night': '夜盘',
    'mc.break': '午间休市',
    'mc.closed': '休市',
    'mc.holiday': '假日',
    'mc.closesIn': '{t} 后收市',
    'mc.opensIn': '{t} 后开市',
    'mc.endsIn': '{t} 后结束',
    'mc.reopensIn': '{t} 后重新开市',
    'mc.preIn': '{t} 后进入盘前',
    'mc.afterIn': '{t} 后进入盘后',
    'mc.nightIn': '{t} 后进入夜盘',
    'mc.openCount': '{n} 个开市',
    'mc.all': '所有市场',
    "mc.title": "交易时间",
    "side.countries": "国家",
    "side.menu": "菜单",
    "tools.pricingSub": "各方案及其包含的内容",
    'mc.noHolidays': '未含假日',
    'mc.local': '当地时间',
    'mc.note': '各交易所当地时间的常规交易时段。已包含美国、英国、德国和泛欧交易所巴黎市场的假日（2026–27）；其他交易所可能在当地假日休市。夜盘为股指期货交易时段（东京 OSE、香港 HKFE）。',
    'topic.markets': '市场新闻涉及股票、债券、货币和大宗商品的价格：投资者在买卖什么，以及原因。',
    'topic.economy': '经济新闻（增长、就业、通胀、贸易）会影响未来几个月的企业利润和央行决策。',
    'topic.central-banks': '央行设定利率，也就是资金的价格，它影响贷款、储蓄、汇率和资产价格。',
    'topic.policy': '政府决策（税收、预算、贸易规则、制裁、选举、冲突）可能改变整个行业的成本和风险。',
    'topic.companies': '公司新闻（业绩、交易、裁员）可能影响该公司股价，有时还会影响整个行业。',
    "snap.title": "投资者速览",
    "snap.source": "最新官方年度数据 · 世界银行开放数据。仅供参考，不是预测或投资建议。",
    "snap.gdp_growth": "GDP 增长",
    "snap.inflation": "通胀",
    "snap.unemployment": "失业率",
    "snap.gdp_per_capita": "人均 GDP",
    "snap.current_account": "经常账户",
    "snap.exports": "出口",
    "snap.ofGdp": "占 GDP",
    "snap.gdp.shrink": "经济在萎缩。",
    "snap.gdp.slow": "增长缓慢。",
    "snap.gdp.moderate": "温和增长。",
    "snap.gdp.fast": "快速增长。",
    "snap.inf.deflation": "物价在下降（通缩）。",
    "snap.inf.target": "接近多数央行设定的约 2% 目标。",
    "snap.inf.above": "高于央行的常见目标。",
    "snap.inf.high": "高通胀：货币快速贬值。",
    "snap.unemp.low": "较低：就业市场紧张。",
    "snap.unemp.moderate": "中等。",
    "snap.unemp.high": "较高：很多人找不到工作。",
    "snap.gdppc.note": "人均经济产出：衡量一个国家富裕程度的粗略指标。",
    "snap.ca.surplus": "顺差：从国外的收入多于支出。",
    "snap.ca.deficit": "逆差：对外支出多于收入，依赖外国资金。",
    "snap.exp.very": "高度依赖贸易：对关税和全球需求很敏感。",
    "snap.exp.open": "开放型贸易经济。",
    "snap.exp.domestic": "主要由国内市场驱动。",
    "auth.since": "注册于 {date}",
    "auth.followed": "你关注的国家",
    "auth.noneFollowed": "还没有。在任意国家点击 ☆ 关注，即可添加到这里。",
    "auth.unfollow": "取消关注 {country}",
    "auth.email": "邮件",
    "auth.prefUpdates": "NewsNetWide 更新",
    "auth.prefUpdatesSub": "新功能和网站动态",
    "auth.prefNews": "简报",
    "auth.prefNewsSub": "市场新闻精选",
    "auth.saved": "已保存。",
    "auth.prefsError": "邮件设置暂时不可用。",
    "auth.plan": "方案",
    "auth.seePlans": "查看方案",
    "auth.manage": "管理订阅",
    "auth.trialUntil": "免费试用至 {date}",
    "auth.renews": "{date} 续订",
    "auth.endsOn": "{date} 结束",
    "auth.briefing": "早间简报",
    "auth.briefingOn": "每天早上给我发送简报",
    "auth.briefingSub": "你关注的国家的头条新闻，以及即将到来的重要日期。可随时退订。",
    "auth.briefingNone": "你还没有关注任何国家，因此简报将从全球头条开始。",
    "auth.briefingCount": "简报中的国家：{n}",
    "auth.briefingAt": "发送时间",
    "auth.briefingTz": "你的时间（{tz}）",
    "auth.briefingPreview": "查看今天的示例 ↗",
    "panel.page": "国家页面 ↗",
    "footer.countries": "国家",
    glossary: {
        'central-bank': ['中央银行', '负责制定一国利率并管理货币供应的机构。', '其决策改变所有人的借贷成本，并影响债券、股票和汇率。'],
        fed: ['美联储', '美国的中央银行；其联邦公开市场委员会（FOMC）决定美国利率。', '美国利率影响全球的借贷成本和资金流向。'],
        ecb: ['欧洲央行', '使用欧元的 20 个国家的中央银行。', '其利率决策影响欧元区的房贷、企业贷款和欧元汇率。'],
        boe: ['英国央行', '英国的中央银行；其货币政策委员会决定英国利率。', '其决策影响英镑、英国国债和英国的借贷成本。'],
        boj: ['日本央行', '日本的中央银行。', '日本极低利率的变化可能影响日元和全球资金流动。'],
        'interest-rate': ['利率', '借钱的价格，通常以年百分比表示。', '利率上升会让贷款更贵、通常抑制消费；利率下降则相反。'],
        'rate-cut': ['降息', '央行下调利率。', '更便宜的借贷可以支持消费和企业利润，但也可能反映对经济的担忧。'],
        'rate-hike': ['加息', '央行上调利率。', '通常是为了抑制通胀，家庭和企业的借贷成本随之上升。'],
        'basis-points': ['基点', '1 个基点等于 0.01%；25 个基点即 0.25 个百分点。', '利率变化以基点表示，可以看出变动幅度。'],
        qe: ['量化宽松（QE）', '央行大量购买（QE）或减持（QT）债券，以影响长期利率。', '它改变流入金融市场的资金量。'],
        inflation: ['通胀', '物价上涨的速度，通常用消费者物价指数（CPI）衡量。', '高通胀可能让央行维持高利率，也会降低货币购买力。'],
        gdp: ['GDP', '国内生产总值：一个经济体生产的商品和服务的总价值。', '它是衡量经济增长或萎缩最全面的指标。'],
        recession: ['经济衰退', '经济活动显著而广泛的下滑，常指 GDP 连续两个季度下降。', '衰退通常意味着企业利润下降和失业上升。'],
        unemployment: ['失业', '想工作却没有工作的人所占比例；非农就业数据统计新增岗位。', '就业数据反映经济强弱，并影响央行决策。'],
        pmi: ['采购经理人指数（PMI）', '每月的企业活动调查。高于 50 表示扩张。', '它是判断经济走向最早的信号之一。'],
        'trade-deficit': ['贸易差额', '一国出口与进口之间的差额。', '巨大的失衡可能影响汇率并引发贸易争端。'],
        tariff: ['关税', '对进口商品征收的税。', '关税提高进口成本，也可能减少出口商的销售和利润。'],
        sanctions: ['制裁', '一国对另一国在贸易或金融上施加的限制。', '制裁可能切断市场、扰乱供应链并影响大宗商品价格。'],
        budget: ['预算与财政政策', '政府如何征税、支出和借债。', '巨额赤字或刺激措施可能影响增长、债券收益率和汇率。'],
        'bond-yield': ['债券收益率', '投资者持有债券获得的回报；债券价格下跌时，收益率上升。', '国债收益率决定了整个经济借贷成本的基准。'],
        index: ['股票指数', '追踪某个市场的一篮子股票，例如标普 500（500 家美国大公司）。', '指数用一个数字概括整个市场的表现。'],
        'sell-off': ['抛售', '许多投资者同时卖出、价格快速下跌的时期。', '通常反映恐慌或坏消息，并不能确定之后的走势。'],
        volatility: ['波动性', '价格上下变动的幅度和速度。', '波动性越高，不确定性越大，涨跌幅度也越大。'],
        currency: ['汇率', '一种货币以另一种货币表示的价格。', '汇率变动会改变进口、旅行的成本以及海外投资的价值。'],
        oil: ['油价', '原油的市场价格；布伦特和 WTI 是主要基准。欧佩克（OPEC）是产油国组织。', '石油影响燃料、运输和生产成本，进而影响通胀。'],
        gold: ['黄金', '作为大宗商品交易的黄金。', '许多投资者在不确定时期买入黄金，因此金价常反映市场情绪。'],
        crypto: ['加密货币', '比特币等数字资产，全天候交易，没有央行。', '价格波动很大，会对监管和风险偏好作出反应。'],
        etf: ['ETF', '像股票一样在交易所交易、通常追踪某个指数的基金。', 'ETF 是投资整个市场的常见低成本方式。'],
        earnings: ['盈利', '公司在某一期间公布的利润，常以每股收益（EPS）表示。', '业绩高于或低于分析师预期，往往会推动股价变动。'],
        revenue: ['营收', '公司销售产品或服务获得的全部收入（未扣除成本）。', '营收增长反映公司产品的需求是否在上升。'],
        guidance: ['业绩指引', '公司自己对未来业绩的预测。', '指引的变化对投资者来说往往和过去的业绩一样重要。'],
        ipo: ['首次公开募股（IPO）', '公司首次在证券交易所出售股票。', '让公众可以投资该公司，也反映市场对新上市的兴趣。'],
        merger: ['并购', '一家公司与另一家合并或收购另一家。', '交易可能改变行业竞争格局，常常带动两家公司的股价。'],
        buyback: ['股票回购', '公司从市场买回自己的股票。', '它向股东返还资金并减少股票数量，但不代表价值保证。'],
        dividend: ['股息', '分配给股东的一部分利润。', '股息的变化反映公司对自身现金状况的信心。'],
        layoffs: ['裁员', '公司减少员工数量。', '可能反映成本压力或重组，并影响就业市场。'],
        bankruptcy: ['破产', '公司无法偿还债务时的法律程序。', '股东通常会损失大部分投资，债权人可能收回一部分。'],
    },
    // Calendar (/calendar)
    "nav.calendar": "日历",
    "nav.tools": "工具",
    "nav.pricing": "价格",
    "tools.soon": "即将推出",
    "tools.briefing": "早间简报",
    "tools.briefingSub": "每天早上通过邮件接收你关注国家的新闻",
    "tools.calculators": "金融计算器",
    "tools.calculatorsSub": "复利、储蓄目标、费用",
    "tools.holdings": "持仓关注",
    "tools.holdingsSub": "你持有公司的相关新闻",
    "tools.papers": "论文分析",
    "tools.papersSub": "任何研究论文，用通俗语言解释",
    "tools.montecarlo": "蒙特卡洛模拟器",
    "tools.montecarloSub": "储蓄、交易与期权策略，附 PDF",
    "cal.title": "经济日历",
    "cal.sub": "央行利率决议、重要经济数据、市场休市和公共假日，来自官方来源，按你的时区显示。",
    "cal.todayLabel": "今天",
    "cal.tomorrow": "明天",
    "cal.yesterday": "昨天",
    "cal.allDay": "全天",
    "cal.now": "现在",
    "cal.inDH": "{d} 天 {h} 小时后",
    "cal.inHM": "{h} 小时 {m} 分钟后",
    "cal.inM": "{m} 分钟后",
    "cal.decision": "{bank}：利率决议",
    "cal.closed": "{exchange} 休市",
    "cal.early": "{exchange} 提前收市",
    "cal.estimated": "预计日期",
    "cal.yourTz": "时间按你的时区显示（{tz}）",
    "cal.type.public_holiday": "公共假日",
    "cal.allCountries": "所有国家",
    "cal.yourCountries": "你关注的国家",
    "cal.noFollows": "在地球仪上关注国家后，即可在这里按它们筛选。",
    "cal.addToCal": "添加到日历",
    "cal.subscribe": "订阅",
    "cal.subscribeHint": "将此链接复制到 Google 日历、Apple 日历或 Outlook（“通过网址添加”）。它会自动更新。",
    "cal.copied": "链接已复制",
    "cal.source": "官方来源",
    "cal.relatedNews": "{country} 新闻",
    "cal.period": "统计期：{period}",
    "cal.none": "在这些筛选条件下没有安排。",
    "cal.error": "日历暂时无法使用，请稍后再试。",
    "cal.comingUp": "即将发生",
    "cal.fullCalendar": "完整日历",
    "cal.euroArea": "欧元区",
    "cal.note": "日期和时间来自各央行、交易所和统计机构（每个事件都有链接）。公共假日：开源库“holidays”（MIT 许可）。我们从不显示预测。新闻与背景信息，不构成投资建议。",
    "cal.series.us_cpi": "美国消费者价格指数（CPI）",
    "cal.series.us_jobs": "美国就业报告",
    "cal.series.us_ppi": "美国生产者价格指数（PPI）",
    "cal.series.us_jolts": "美国职位空缺（JOLTS）",
    "cal.series.us_eci": "美国就业成本指数",
    "cal.series.us_gdp": "美国 GDP",
    "cal.series.us_pce": "美国个人收入与支出（PCE）",
    "cal.series.us_trade": "美国贸易差额",
    "cal.series.ea_hicp_flash": "欧元区通胀（快报）",
    "cal.series.ea_hicp": "欧元区通胀（终值）",
    "cal.series.ea_gdp_flash": "欧元区 GDP（初步快报）",
    "cal.series.ea_gdp": "欧元区 GDP 与就业",
    "cal.series.ea_unemployment": "欧元区失业率",
    "cal.series.ea_retail": "欧元区零售销售",
    "cal.series.uk_cpi": "英国消费者价格指数（CPI）",
    "cal.series.uk_gdp_q": "英国 GDP（季度）",
    "cal.series.uk_gdp_m": "英国 GDP（月度）",
    "cal.series.uk_jobs": "英国劳动力市场",
    "cal.series.uk_retail": "英国零售销售",
    "cal.series.au_cpi": "澳大利亚消费者价格指数（CPI）",
    "cal.series.au_jobs": "澳大利亚劳动力调查",
    "cal.series.au_gdp": "澳大利亚 GDP",
    "bank.snb": "瑞士国家银行",
    "bank.boc": "加拿大银行",
    "bank.rba": "澳大利亚储备银行",
    "bank.rbnz": "新西兰储备银行",
    "bank.riksbank": "瑞典央行",
    "bank.norges": "挪威央行",
    "bank.rbi": "印度储备银行",
    "cal.promise1": "仅限官方来源",
    "cal.promise2": "没有预测，只有日期和结果",
    "cal.promise3": "免费日历订阅",
    "cal.yourTimeShort": "你的时间",
    "cal.unitD": "天",
    "cal.unitH": "小时",
    "cal.unitM": "分",
    "cal.approxNote": "大致时间：该央行不提前确定公布时间",
    "cal.then": "之后：",
    "cal.nextDecisions": "即将到来的利率决议",
    "cal.bankCalendars": "央行官方日历 · 距公布倒计时",
    "cal.marketsWeek": "本周股市",
    "cal.mktAside": "本周休市：{n} · 时间按 {tz}",
    "cal.mktNote": "仅显示主要交易时段。休市信息来自各交易所的官方假日表。",
    "cal.exchange": "交易所",
    "cal.rightNow": "当前",
    "cal.mkt.open": "开市",
    "cal.mkt.pre": "尚未开市",
    "cal.mkt.break": "午间休市",
    "cal.mkt.closedToday": "今日休市",
    "cal.mkt.closed": "休市",
    "cal.mkt.closesAt": "你的时间 {time} 收市",
    "cal.mkt.opensAt": "你的时间 {time} 开市",
    "cal.mkt.earlyAt": "{time} 提前收市",
    "cal.local": "当地时间",
    "cal.country": "国家",
    "cal.types": "事件类型",
    "cal.group.central_bank": "央行",
    "cal.group.data_release": "经济数据",
    "cal.group.markets": "市场休市",
    "cal.group.public_holiday": "公共假日",
    "cal.badge.central_bank": "利率决议",
    "cal.badge.data_release": "数据发布",
    "cal.badge.market_closed": "市场休市",
    "cal.badge.early_close": "提前收市",
    "cal.badge.public_holiday": "公共假日",
    "cal.closesEarly": "提前收市",
    "cal.noTrading": "全天无交易",
    "cal.released": "已公布",
    "cal.seeFigure": "查看官方数据",
    "cal.sourceShort": "来源",
    "cal.news": "新闻",
    "cal.openNote": "{exchange} 开市",
    "cal.plusMore": "另外 {n} 个",
    "cal.oneEvent": "1 个事件",
    "cal.nEvents": "{n} 个事件",
    "cal.oneHoliday": "1 个假日",
    "cal.nHolidays": "{n} 个假日",
    "cal.nowLine": "现在 · {time}",
    "cal.weekendClosed": "周末：股市休市。",
    "cal.nothingDay": "没有安排。",
    "cal.thisWeek": "本周",
    "cal.nextWeekLabel": "下周",
    "cal.earlier": "本周早些时候",
    "cal.show": "显示",
    "cal.tryAll": "试试选择所有事件类型，或关闭“你关注的国家”。",
    "cal.reset": "重置筛选",
    "cal.prevWeek": "上一周",
    "cal.nextWeek": "下一周",
    "cal.moreWeek": "显示下一周",
    "cal.subscribeTitle": "订阅此日历",
    "cal.feedAddress": "订阅地址",
    "cal.copyLink": "复制链接",
    "cal.subFine": "免费，无需账号。会按你选择的筛选条件更新。新闻与背景信息，不构成投资建议。",
    "cal.impact": "影响",
    "cal.imp.high": "高",
    "cal.imp.medium": "中",
    "cal.imp.low": "低",
    "cal.impTip.high": "通常会影响利率、汇率和股市",
    "cal.impTip.medium": "市场关注，但较少引起波动",
    "cal.impTip.low": "背景信息：假日、次要数据",
    "cal.impNote": "根据事件类型判断，并非预测。",
    "cal.impAll": "全部",
    "cal.impMediumUp": "中及以上",
    "cal.impHighOnly": "仅高",
    "cal.nHigh": "{n} 个高影响",
    "cal.addShort": "添加",
};
